import { CommonModule } from '@angular/common';
import { MatExpansionModule } from '@angular/material/expansion';
import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TextFieldsComponent, ExternalDropdownComponent, LocationExternalAutocompleteComponent} from '@loup-transload-ui-app/common-components';
import { TransportTypeComponent } from './transport-type/transport-type.component';

@Component({
  selector: 'app-create-lane-twisty',
  standalone: true,
  imports: [ CommonModule, MatExpansionModule, ReactiveFormsModule, TransportTypeComponent, LocationExternalAutocompleteComponent, TextFieldsComponent, ExternalDropdownComponent],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './create-lane-twisty.component.html',
  styleUrl: './create-lane-twisty.component.scss',
})

export class CreateLaneTwistyComponent {
  @ViewChild('cityStateDropdownOrigin') cityStateDropdownOrigin: LocationExternalAutocompleteComponent;
  @ViewChild('cityStateDropdownDestination') cityStateDropdownDestination: LocationExternalAutocompleteComponent;
  @ViewChild('transloadType') transloadType: TransportTypeComponent;
  @ViewChild('truckType') truckType: TransportTypeComponent;
  @ViewChild('storageType') storageType: TransportTypeComponent;
  @ViewChild('potentialUnit') potentialUnit: TextFieldsComponent;
  @ViewChild('volumeDropdown') volumeDropdown: ExternalDropdownComponent;
  @ViewChild('volumeUomDropdown') volumeUomDropdown: ExternalDropdownComponent;
  @Input() group!: FormGroup;
  @Input() indexValue = null;
  @Input() activeLaneIndex = 0;
  @Output() copyLane = new EventEmitter<number>();
  @Output() deleteLane = new EventEmitter<number>();
  @Output() showHideStorage = new EventEmitter<boolean>();
  @Input() isRailSelected = false;
  @Input() isSubmitted = false;
  
  public originCityStateLabel = 'Origin City State';
  public destinationCityStateLabel = 'Destination City State';
  public potentialUnitLabel = 'Potential Units';
  public volumeDurationLabel = 'Unit of Measure';
  public volumeDurationUomLabel = 'Time Frame';
  public showStorage = false;

  onSelected(event, fieldName) {
    if (event && event.length > 0) {
      this.group.get(fieldName)?.setValue(event[0]);
      this.group.get(fieldName)?.markAsTouched();
    } else {
      this.group.get(fieldName)?.setValue(event);
      this.group.get(fieldName)?.markAsTouched();
    }
  }

  fieldValue(event, fieldName) {
    this.group.get(fieldName)?.setValue(event);
    this.group.get(fieldName)?.markAsTouched();
  }

  copyLaneAction(indexValue) {
    this.copyLane.emit(indexValue);
  }
  delateLaneAction(indexValue) {
    this.deleteLane.emit(indexValue);
  }

  transloadNo(selectedValue: boolean) {
    this.showStorage = selectedValue;
    if (selectedValue) {
      this.group.get('storageServicesRequired')?.setValue({
        origin: false,
        destination: false,
        no: false,
      });
    }
  }

  updateFormDate(event: any, fieldName: string) {
    this.group.get(fieldName)?.setValue({
      origin: event.origin,
      destination: event.destination,
      no: event.no,
    });
  }
}
